import tailwindConfig from '../../../../../../../../../tailwind.config';

// Sample figures for the live preview (cents + basis points), mirroring the Figma mock.
export const SAMPLE_CHECKIN = {
  totalCost: 11643,
  payments: 9135,
  paymentsBasisPoints: 7850,
  discounts: 2000,
  discountsBasisPoints: 1720,
  taxesAndFees: 1200,
  taxesBasisPoints: 1030,
  amountDue: 1708,
  patientBasisPoints: 1470,
  costShareLabel: 'Copay $10.00 + coinsurance $7.08'
};

export const SAMPLE_EMAIL = {
  patientFirstName: 'Johnny',
  monthLabel: 'JAN',
  dayLabel: '20',
  dateLabel: 'Tuesday, January 20, 2026',
  timeLabel: '2:00 PM',
  timezoneLabel: 'EST',
  practitionerName: 'Emily Taylor',
  visitType: 'Office visit',
  fallbackPracticeName: 'Your practice',
  fallbackAddress: '128 Willow Avenue, Brooklyn, NY 11201'
};

export const PREVIEW_TABS = [
  { label: 'Check-in (Secure payment)', shortLabel: 'Check-in', value: 'checkin' },
  { label: 'Appointment email', shortLabel: 'Email', value: 'email' }
];

const screenMax = (name) => parseInt(tailwindConfig.theme.screens[name].max, 10);

// The check-in step stacks its cards at the Tailwind screens, measured against the preview pane
// instead of the window since the settings panel takes a varying share of the modal.
export const getPreviewLayout = (width) => ({
  isNarrow: width <= screenMax('sm'),
  isTiny: width <= screenMax('xs')
});
